"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _global = _interopRequireDefault(require("global"));
var _reactToastNotifications = require("react-toast-notifications");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var NotificationContainer = exports.NotificationContainer = function NotificationContainer(props) {
  var _useState = (0, _react.useState)(_global["default"].pageYOffset),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    prevScrollpos = _useState2[0],
    setPrevScrollpos = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isOffset = _useState4[0],
    setIsOffset = _useState4[1];
  (0, _react.useEffect)(function () {
    _global["default"].addEventListener('scroll', handleScroll);
    return function () {
      return _global["default"].removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollpos, _global["default"].pageYOffset]);
  var handleScroll = function handleScroll() {
    var currentScrollPos = _global["default"].pageYOffset;
    setPrevScrollpos(currentScrollPos);
    setIsOffset(prevScrollpos > currentScrollPos || currentScrollPos < 150 || prevScrollpos < 150);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactToastNotifications.DefaultToastContainer, (0, _extends2["default"])({
    className: "d8-c-notification-provider ".concat(isOffset && 'offset')
  }, props));
};